
    import "src/app/AppAdmin/Billing/Wallet/index.module.scss?farm_css_modules";
    
    export default {"balanceDiv": `balanceDiv-f7cc6d3e`,"main": `main-f7cc6d3e`,"open": `open-f7cc6d3e`,"paddedDiv": `paddedDiv-f7cc6d3e`,"topRow": `topRow-f7cc6d3e`,"transactionForm": `transactionForm-f7cc6d3e`,"transactionInfoContainer": `transactionInfoContainer-f7cc6d3e`}
    